import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

import { emptyGeneralStateStorage, emptyMailBox, logoutUser } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { emptySubscriptionStorage } from "../../store/subscription/actions";

const Logout = () => {
  const dispatch = useDispatch();

  const { isUserLogout } = useSelector((state) => ({
    isUserLogout: state.login.isUserLogout
  }));

  useEffect(() => {
    dispatch(emptySubscriptionStorage());
    dispatch(emptyGeneralStateStorage());
    dispatch(emptyMailBox());
    dispatch(logoutUser());
  }, [dispatch]);

  if (isUserLogout) {
    return <Navigate to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object
};

export default withRouter(Logout);
